module.exports = __webpack_public_path__ + "img/loader.b4b140c1.gif";